import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Modal, Tooltip, Typography, Dialog, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import Icon from '@mui/material/Icon'
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined'
import FlipCameraAndroidOutlinedIcon from '@mui/icons-material/FlipCameraAndroidOutlined'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import { useStyles } from '../../CaseDiagnosis/CaseDiagnosisStyles'
import PatientCaseHistory from './PatientCaseHistoryModal'
import TransferCaseModal from '../LabManager/TransferCaseModal'
import TransferCorrectCaseModal from '../LabManager/TransferCorrectCaseModal'
import AmendCaseModal from '../LabManager/AmendCaseModal'
import { RootState } from '../../../reducers'
import { CaseStatus } from '../../../utils/displayLabels'
import DeleteDialog from '../../HOC/DeleteDialog'
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined'
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined'
import GroupRemoveOutlinedIcon from '@mui/icons-material/GroupRemoveOutlined'
import AssignCaseModal from '../LabManager/AssignCaseModal'
import SuccessSnackBar from '../../HOC/SuccesSnackBar'
import ErrorSnackBar from '../../HOC/ErrorSnackBar'
import LaunchPremeris from '../../CaseDiagnosis/LaunchPremeris'
import CircularProgress from '@mui/material/CircularProgress'
import {
  amend,
  getLabManagerCompleteData,
  unassignCase,
  getITAdminAssignedData,
  getITAdminCompleteData,
  refreshCaseData,
  setDraftEmpty,
  saveReportData,
  amendReportUpload,
  clearSessionToken,
} from '../../../actions'
import { DataGrid, GridSortModel } from '@mui/x-data-grid'
import { clearPremerisApiCache, clearPremerisReportApiCache, setCaseData } from '../../../actions'
import CustomDatagridDateRangeFilter from '../Common/CustomDatagridDateRangeFilter'
import { GridFilterItem, GridFilterOperator, getGridStringOperators, GridFilterModel } from '@mui/x-data-grid'
import CustomDatagridDropDownFilter from '../Common/CustomDatagridDropDownFilter'

interface userObj {
  id?: number
  case_id?: number
  user_id?: string
  slide_status_id?: number
}

function TableComponent({ userId, caseView, reducerData, dispatchData, tableColumns, isSearchTable }) {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [transferModalOpen, setTransferModalOpen] = useState(false)
  const [correctionTransferModalOpen, setCorrectionTransferModalOpen] = useState(false)
  const [amendModalOpen, setAmendModalOpen] = useState(false)
  const [resetAssignmentOpen, setResetAssignmentOpen] = useState(false)
  const dispatch = useDispatch()
  const { display_labels } = useSelector((state: RootState) => state.appConfig)
  const { role, user } = useSelector((state: RootState) => state.userLogin)
  const refreshData = useSelector((state: RootState) => state.refreshCase)
  const [userDetails, setUserDetails] = useState<userObj>({})
  const gridPageSize = 10
  const [assignModalOpen, setAssignModalOpen] = useState(false)
  const [openSnackBar, setOpenSnackBar] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pageValue, setPageValue] = useState(0)
  const [isFirstPage, setFirstPage] = useState(false)
  const caseData = useSelector((state: RootState) => state.getCaseData)
  const [findUrl, setFindUrl] = useState('')
  const [premerisOpen, setPremerisOpen] = useState(false)
  const [isReadOnlyMode, setReadOnlyMode] = useState(false)
  const { re_unassignCase_success, re_unassignCase_error } = useSelector((state: RootState) => state.unassignResponse)
  const { re_amend_success, re_amend_error } = useSelector((state: RootState) => state.amendResponse)
  const [loadingStatus, setLoadingStatus] = useState(false)
  const [isInitiateAmendOpen, setInitiateAmendOpen] = useState(false)
  const [isAmendFlow, setAmendFlow] = useState(false)
  const [filterValue, setFilterValue] = useState('')
  const [filterName, setFilterName] = useState('')
  const [sortOrder, setSortOrder] = useState('asc')
  const [sortField, setSortField] = useState(caseView === 'completed' ? 'updated_datetime' : 'created_datetime')
  const [isFilter, setFilter] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const { re_amendReport_success, re_amendReport_error } = useSelector((state: RootState) => state.saveAmendResponse)
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const [columnModel, setColumnModel] = useState(caseView === 'completed' ? 'updated_datetime' : 'created_datetime')
  const [sortModel, setSortModel] = useState<GridSortModel>([{ field: sortField, sort: null }])

  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [
      {
        id: 1,
        columnField: 'quantity',
        value: [5000, 15000],
        operatorValue: 'between',
      },
    ],
  })

  useEffect(() => {
    setFindUrl(window.location.pathname)
  }, [])

  const displayAssignedData = reducerData.data
  const totalCount = reducerData.total_count
  const ActionsIconRender = {
    field: '',
    headerName: 'Actions',
    disableColumnMenu: true,
    width: 140,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    filterable: false,
    renderCell: (params) => {
      const disableTransferStages = [
        'PRIMARY_DIAGNOSIS_RESULTED_2HRWINDOW',
        'PRIMARY_DIAGNOSIS_RESULTED_RESULT_RELEASED',
        'AMEND_RESULTED_RESULT_RELEASED',
        'CORRECT_RESULTED_2HRWINDOW',
        'CORRECT_RESULTED_RESULT_RELEASED',
      ]
      const unassignTransferStages = [
        'PRIMARY_DIAGNOSIS_ASSIGNED_INITIAL',
        'PRIMARY_DIAGNOSIS_ASSIGNED_READY',
        'PRIMARY_DIAGNOSIS_ASSIGNED_INPROGRESS',
        'PRIMARY_DIAGNOSIS_ASSIGNED_CONSULT',
      ]
      return (
        <div>
          <Tooltip title="Case History" placement="top-start">
            <Icon onClick={(event) => handleOpen(event, params.row)}>info_outlined</Icon>
          </Tooltip>
          {params.row.stage_id !== 'PRIMARY_DIAGNOSIS_NO_SLOTS_INITIAL' &&
            disableTransferStages.includes(params.row.stage_id) === false && (
              <>
                &nbsp;&nbsp;&nbsp;
                <Tooltip title="Transfer case" placement="top-start">
                  <PeopleAltOutlinedIcon onClick={(event) => handleTransferModalOpen(event, params.row)}>
                    Transfer
                  </PeopleAltOutlinedIcon>
                </Tooltip>
              </>
            )}
          {params.row.stage_id === 'PRIMARY_DIAGNOSIS_NO_SLOTS_INITIAL' && (
            <>
              &nbsp;&nbsp;&nbsp;
              <Tooltip title="Assign case" placement="top-start">
                <GroupAddOutlinedIcon onClick={(event) => handleAssignModalOpen(event, params.row)}>
                  Assign
                </GroupAddOutlinedIcon>
              </Tooltip>
            </>
          )}
          {unassignTransferStages.includes(params.row.stage_id) && (
            <>
              &nbsp;&nbsp;&nbsp;
              <Tooltip title="Unassign case" placement="top-start">
                <GroupRemoveOutlinedIcon onClick={(event) => handleResetAssignmentOpen(event, params.row)}>
                  Unassign case
                </GroupRemoveOutlinedIcon>
              </Tooltip>
            </>
          )}
          {(params.row.stage_id === 'PRIMARY_DIAGNOSIS_RESULTED_RESULT_RELEASED' ||
            params.row.stage_id === 'CORRECT_RESULTED_RESULT_RELEASED' ||
            params.row.stage_id === 'AMEND_RESULTED_RESULT_RELEASED') && (
            <>
              &nbsp;&nbsp;&nbsp;
              <Tooltip title="Correction" placement="top-start">
                <BuildOutlinedIcon onClick={(event) => handleCorrectionTransferModalOpen(event, params.row)}>
                  Correction
                </BuildOutlinedIcon>
              </Tooltip>
            </>
          )}
          {(params.row.stage_id === 'PRIMARY_DIAGNOSIS_RESULTED_RESULT_RELEASED' ||
            params.row.stage_id === 'CORRECT_RESULTED_RESULT_RELEASED' ||
            params.row.stage_id === 'AMEND_RESULTED_RESULT_RELEASED') && (
            <>
              &nbsp;&nbsp;&nbsp;
              <Tooltip title="Initiate Amendment" placement="top-start">
                <FlipCameraAndroidOutlinedIcon
                  onClick={(event) => handleInitiateAmend(event, params.row.case_id, reducerData.data)}
                >
                  Initiate Amendment
                </FlipCameraAndroidOutlinedIcon>
              </Tooltip>
            </>
          )}
        </div>
      )
    },
  }
  const CaseStatusRenderer = {
    field: 'workflow_stage_id',
    headerName: 'Case Status',
    width: 230,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    sortable: true,
    renderCell: (params) => {
      const caseStatus = CaseStatus(params.row.stage_id, role, display_labels)
      const statusArray = caseStatus.labelStr.split(', ')
      const style = { backgroundColor: caseStatus.labelColor }
      return (
        <>
          {statusArray.map((caseStatus, i) => (
            // eslint-disable-next-line react/jsx-key
            <React.Fragment key={i}>
              <Tooltip title={caseStatus} placement="top-start">
                <Stack direction="row" spacing={2}>
                  <Chip className={classes.chipSpacing} color="primary" style={style} label={caseStatus} />
                </Stack>
              </Tooltip>
            </React.Fragment>
          ))}
        </>
      )
    },
  }

  const handleFilter = useCallback(
    (obj) => {
      setFilter(true)
      setFilterName(obj.filterField)
      setFilterValue(obj.filterValue)
      setStartDate(obj.startDate)
      setEndDate(obj.endDate)
      setSortField(obj.sortField ? obj.sortField : caseView === 'completed' ? 'updated_datetime' : 'created_datetime')
    },
    [isFilter],
  )

  const dropdownOnlyOperators: GridFilterOperator[] = [
    {
      label: 'List',
      value: 'list',
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
          return null
        }
        if (filterItem.value[0] == null || filterItem.value[1] == null) {
          return null
        }

        return null
      },
      InputComponent: CustomDatagridDropDownFilter,
      InputComponentProps: { handleFilter, sortField: sortField, caseView: caseView },
    },
  ]

  const dateRangeOperators: GridFilterOperator[] = [
    {
      label: 'Between',
      value: 'between',
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
          return null
        }
        if (filterItem.value[0] == null || filterItem.value[1] == null) {
          return null
        }

        return null
      },
      InputComponent: CustomDatagridDateRangeFilter,
      InputComponentProps: { handleFilter, sortField: sortField, caseView: caseView },
    },
  ]

  const ColumnsCustomFilters = (columnsData: any) => {
    const newtableColumns = [...columnsData]

    if (newtableColumns.length > 0) {
      const assignedDateIndex = newtableColumns.findIndex((col) => col.headerName === 'Assigned Date')
      const createdDateIndex = newtableColumns.findIndex((col) => col.headerName === 'Created On')
      const assignedIndex = newtableColumns.findIndex((col) => col.headerName === 'Assigned To')
      const caseTypeIndex = newtableColumns.findIndex((col) => col.headerName === 'Case Type')
      const priorityIndex = newtableColumns.findIndex((col) => col.headerName === 'Priority')
      const workflowIndex = newtableColumns.findIndex((col) => col.headerName === 'Case Status')
      const statesIndex = newtableColumns.findIndex((col) => col.headerName === 'State')
      const releaseDateIndex = newtableColumns.findIndex((col) => col.headerName === 'Time of Release')
      const assignedOnDate = newtableColumns.findIndex((col) => col.headerName === 'Assigned On')
      const completedIndex = newtableColumns.findIndex((col) => col.headerName === 'Signature')
      const resultIndex = newtableColumns.findIndex((col) => col.headerName === 'Result')
      const patientNameIndex = newtableColumns.findIndex((col) => col.headerName === 'Patient Name')
      const trfIdIndex = newtableColumns.findIndex((col) => col.headerName === 'TRF ID')

      if (releaseDateIndex !== -1) {
        newtableColumns[releaseDateIndex] = {
          ...newtableColumns[releaseDateIndex],
          filterOperators: dateRangeOperators,
        }
      }
      if (assignedOnDate !== -1) {
        newtableColumns[assignedOnDate] = {
          ...newtableColumns[assignedOnDate],
          filterOperators: dateRangeOperators,
        }
      }
      if (assignedDateIndex !== -1) {
        newtableColumns[assignedDateIndex] = {
          ...newtableColumns[assignedDateIndex],
          filterOperators: dateRangeOperators,
        }
      }
      if (createdDateIndex !== -1) {
        newtableColumns[createdDateIndex] = {
          ...newtableColumns[createdDateIndex],
          filterOperators: dateRangeOperators,
        }
      }
      if (resultIndex !== -1) {
        newtableColumns[resultIndex] = {
          ...newtableColumns[resultIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }
      if (completedIndex !== -1) {
        newtableColumns[completedIndex] = {
          ...newtableColumns[completedIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }

      if (assignedIndex !== -1) {
        newtableColumns[assignedIndex] = {
          ...newtableColumns[assignedIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }
      if (caseTypeIndex !== -1) {
        newtableColumns[caseTypeIndex] = {
          ...newtableColumns[caseTypeIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }
      if (priorityIndex !== -1) {
        newtableColumns[priorityIndex] = {
          ...newtableColumns[priorityIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }
      if (workflowIndex !== -1) {
        newtableColumns[workflowIndex] = {
          ...newtableColumns[workflowIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }
      if (statesIndex !== -1) {
        newtableColumns[statesIndex] = {
          ...newtableColumns[statesIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }
      if (patientNameIndex !== -1) {
        newtableColumns[patientNameIndex] = {
          ...newtableColumns[patientNameIndex],
          filterOperators: getGridStringOperators().filter((operator) => operator.value === 'contains'),
        }
      }
      if (trfIdIndex !== -1) {
        newtableColumns[trfIdIndex] = {
          ...newtableColumns[trfIdIndex],
          filterOperators: getGridStringOperators().filter((operator) => operator.value === 'startsWith'),
        }
      }
    }

    return newtableColumns
  }

  tableColumns.push(CaseStatusRenderer)
  role !== 'NL_Pathologist' ? tableColumns.push(ActionsIconRender) : console.log('pathologist role')
  const handleOpen = (event, rowData: any) => {
    setUserDetails(rowData)
    setOpen(true)
  }

  const handleTransferModalOpen = (event, row: any) => {
    setUserDetails(row)
    setTransferModalOpen(true)
  }

  const handleCorrectionTransferModalOpen = (event, row: any) => {
    setUserDetails(row)
    setCorrectionTransferModalOpen(true)
  }

  const handleAmendModalOpen = (event, row: any) => {
    setUserDetails(row)
    setAmendModalOpen(true)
  }

  const handleResetAssignmentOpen = (event, row: any) => {
    setUserDetails(row)
    setResetAssignmentOpen(true)
  }

  const handleResetAssignmentClose = () => {
    setResetAssignmentOpen(false)
  }

  const handleTransferModalClose = () => {
    setTransferModalOpen(false)
  }

  const handleCorrectionTransferModalClose = () => {
    setCorrectionTransferModalOpen(false)
  }

  const handleAmendModalClose = () => {
    setAmendModalOpen(false)
  }

  const handleAssignModalOpen = (event, row: any) => {
    setUserDetails(row)
    setAssignModalOpen(true)
  }

  const handleAssignModalClose = () => {
    setAssignModalOpen(false)
  }

  const handleClose = () => setOpen(false)

  const handleSubmit = async () => {
    await dispatch(
      unassignCase({
        caseid: userDetails.case_id,
        currentid: userDetails.user_id ? userDetails.user_id : user,
        userid: userId,
      }),
    )
    setOpenSnackBar(true)
    setFirstPage(true)
    await dispatch(
      getITAdminAssignedData({
        id: `${userDetails.user_id}`,
        pageIndex: 1,
        pageSize: gridPageSize,
        filterField: filterName !== '' ? filterName : 'created_datetime',
        filterValue: filterValue,
        caseView: 'assigned',
        startDate: startDate,
        endDate: endDate,
        sortOrder: 'asc',
        sortField: sortField,
      }),
    )
    setFirstPage(true)
    handleResetAssignmentClose()
  }

  const handleAmendCase = async (event, caseid: any, newUserId) => {
    setLoading(true)
    await dispatch(
      amend({
        userid: userId,
        newid: newUserId,
        caseid: userDetails?.case_id,
      }),
    )
    await updateDataTable()
  }

  const updateDataTable = async () => {
    if (role === 'NL_LabManager')
      await dispatch(
        getLabManagerCompleteData({
          id: `${userId}`,
          pageIndex: 1,
          pageSize: gridPageSize,
          filterField: filterName !== '' ? filterName : 'updated_datetime',
          filterValue: null,
          caseView: 'completed',
          startDate: null,
          endDate: null,
          sortOrder: 'desc',
          sortField: sortField,
        }),
      )
    else if (role === 'NL_WOMA_ADMIN')
      await dispatch(
        getITAdminCompleteData({
          id: `${userId}`,
          pageIndex: 1,
          pageSize: gridPageSize,
          filterField: filterName !== '' ? filterName : 'updated_datetime',
          filterValue: null,
          caseView: 'completed',
          startDate: null,
          endDate: null,
          sortOrder: 'desc',
          sortField: sortField,
        }),
      )
    setFirstPage(true)
    handleAmendModalClose()
    setLoading(false)
    setInitiateAmendOpen(false)
    setOpenSnackBar(true)
  }

  const handlePremerisOpen = async (event, caseId: any, data) => {
    const filterAssignedResults = data.filter((value) => {
      return value.case_id == caseId
    })
    const patientName = `${filterAssignedResults[0].patient_last_name || ''}, ${
      filterAssignedResults[0].patient_first_name || ''
    }`
    setLoading(true)
    await handleRefreshCases(filterAssignedResults[0].case_number + '000')
    dispatch(
      setCaseData({
        pathologist: { first_name: filterAssignedResults[0].first_name, last_name: filterAssignedResults[0].last_name },
        pathologistId: filterAssignedResults[0].user_id,
        caseNumber: filterAssignedResults[0].case_number,
        procedureCodeId: filterAssignedResults[0].procedure_code,
        workflowId: filterAssignedResults[0].stage_id,
        patientName: patientName,
        caseId: caseId,
        nlOrderId: filterAssignedResults[0].nl_order_id,
        userCaseWorkflowId: filterAssignedResults[0].id,
        slideStatusId: filterAssignedResults[0].slide_status_id,
        mcFlag: filterAssignedResults[0].mc_flag,
        statFlag: filterAssignedResults[0].stat_flag,
      }),
    )
    setLoading(false)
    setPremerisOpen(true)
  }

  const handleInitiateAmend = (event, caseId: any, data) => {
    setInitiateAmendOpen(true)
    setAmendFlow(true)
    setLoadingStatus(true)
    ammendPremerisOpen(caseId, data)
  }

  const handleInitiateAmendClose = () => {
    setPremerisOpen(true)
  }

  const ammendPremerisOpen = async (caseId, data) => {
    /* Emptying the get draft report data when different case is selected, to prevent caching */
    dispatch(setDraftEmpty({ draft: {} }))
    const filterAssignedResults = data?.filter((value) => {
      return value.case_id == caseId
    })
    const patientName = `${filterAssignedResults[0].patient_last_name || ''}, ${
      filterAssignedResults[0].patient_first_name || ''
    }`
    await handleRefreshCases(filterAssignedResults[0].case_number + '000')
    dispatch(
      setCaseData({
        pathologist: { first_name: filterAssignedResults[0].first_name, last_name: filterAssignedResults[0].last_name },
        pathologistId: filterAssignedResults[0].user_id,
        caseNumber: filterAssignedResults[0].case_number,
        procedureCodeId: filterAssignedResults[0].procedure_code,
        workflowId: 'AMEND_INITIATED',
        patientName: patientName,
        caseId: caseId,
        nlOrderId: filterAssignedResults[0].nl_order_id,
        userCaseWorkflowId: filterAssignedResults[0].id,
        slideStatusId: filterAssignedResults[0].slide_status_id,
        mcFlag: filterAssignedResults[0].mc_flag,
        statFlag: filterAssignedResults[0].stat_flag,
      }),
    )
    setAmendFlow(true)
    setReadOnlyMode(true)
    setTimeout(() => {
      handleInitiateAmendClose()
    }, 3000)
  }

  const handleRefreshCases = async (trfBarcode) => {
    await dispatch(refreshCaseData({ trfBarcode: trfBarcode }))
    await dispatch(clearPremerisApiCache())
    await dispatch(clearPremerisReportApiCache())
  }

  const handlePremerisClose = async () => {
    updateTrfStartDataTable()
    setInitiateAmendOpen(false)
    setAmendFlow(false)
    await dispatch(clearPremerisApiCache())
    await dispatch(clearPremerisReportApiCache())
    setPremerisOpen(false)
  }

  const updateTrfStartDataTable = async () => {
    dispatch(
      getLabManagerCompleteData({
        id: `${userId}`,
        pageIndex: 1,
        pageSize: gridPageSize,
        filterField: filterName !== '' ? filterName : 'updated_datetime',
        filterValue: filterValue,
        caseView: 'completed',
        startDate: startDate,
        endDate: endDate,
        sortOrder: 'desc',
        sortField: sortField,
      }),
    )
  }

  const onFilterChange = async (model: GridFilterModel) => {
    setFilterName('')
    setFilterValue('')
    setStartDate('')
    setEndDate('')
    setFilterModel(model)
    if (model.items.length && model.items[0].value) {
      await onFilterApply(model)
    } else {
      await clearFilter() // first time...dont call
      setFilter(false)
    }
  }

  const clearFilter = async () => {
    await dispatch(
      dispatchData({
        id: `${userId}`,
        pageIndex: pageValue,
        pageSize: gridPageSize,
        filterField:
          filterName !== '' ? filterName : caseView === 'completed' ? 'updated_datetime' : 'created_datetime',
        filterValue: null,
        caseView: caseView,
        startDate: null,
        endDate: null,
        sortOrder: 'asc',
        sortField: sortField,
      }),
    )
  }
  const onFilterApply = React.useCallback(async (model: GridFilterModel) => {
    if (model.items.length) {
      if (
        (model.items[0].columnField === 'patient_first_name' || model.items[0].columnField === 'case_number') &&
        model.items[0].value &&
        model.items[0].value.length
      ) {
        const val = model.items[0].value
        setFilterValue(val)
        const name = model.items[0].columnField
        setFilterName(name)
        await dispatch(
          dispatchData({
            id: userId,
            caseView: caseView,
            filterField: model.items[0].columnField,
            filterValue: val,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            pageIndex: 0,
            pageSize: 10,
            sortField: sortField,
          }),
        )
        setFilter(true)
      }
    }
  }, [])

  const handlePageChange = async (page: any, details: any) => {
    await dispatch(
      dispatchData({
        id: `${userId}`,
        caseView: caseView,
        filterField: filterName !== '' ? filterName : sortField,
        filterValue: filterValue,
        startDate: startDate,
        endDate: endDate,
        sortOrder: sortOrder,
        pageIndex: page + 1,
        pageSize: gridPageSize,
        sortField: sortField,
      }),
    )
  }

  const handleFilteredPageChange = async (page: any, details: any) => {
    setSortOrder(details[0].sort)
    await dispatch(
      dispatchData({
        id: `${userId}`,
        caseView: caseView,
        filterField: filterName !== '' ? filterName : details[0].field,
        filterValue: filterValue,
        startDate: startDate,
        endDate: endDate,
        sortOrder: details[0].sort ? details[0].sort : 'asc',
        sortField: details[0].field,
        pageIndex: page + 1,
        pageSize: gridPageSize,
      }),
    )
  }

  const handleTRFComplete = () => {
    dispatch(
      saveReportData({
        trfBarcode: null,
        cptCodes: [],
        saveDraftJSON: {},
        reason: '',
        diagnosisLP: {},
        consultLP: [],
        calloutDecision: false,
        procedureCode: null,
      }),
    )
    dispatch(clearSessionToken())
    setTimeout(updateCaseStatus, 1500)
  }

  const updateCaseStatus = async () => {
    setOpenSuccessSnackBar(true)
    dispatch(
      setCaseData({
        pathologist: caseData.pathologist,
        pathologistId: caseData.pathologistId,
        caseNumber: caseData.caseNumber,
        procedureCodeId: caseData.procedureCodeId,
        workflowId: 'AMEND_RESULTED_RESULT_RELEASED',
        patientName: caseData.patientName,
        caseId: caseData.caseId,
        nlOrderId: caseData.nlOrderId,
        userCaseWorkflowId: caseData.userCaseWorkflowId,
        slideStatusId: caseData.slideStatusId,
        mcFlag: caseData.mcFlag,
        statFlag: caseData.statFlag,
      }),
    )
    dispatch(
      amendReportUpload({
        pathologistId: '',
        caseNumber: '',
        caseId: '',
        nlOrderId: '',
        userCaseWorkflowId: '',
        slideStatusId: '',
        mcFlag: '',
        statFlag: '',
        userId: '',
      }),
    )
    dispatch(
      dispatchData({
        id: `${userId}`,
        pageIndex: pageValue,
        pageSize: gridPageSize,
        filterField:
          filterName !== '' ? filterName : caseView === 'completed' ? 'updated_datetime' : 'created_datetime',
        filterValue: null,
        caseView: caseView,
        startDate: null,
        endDate: null,
        sortOrder: 'asc',
        sortField: sortField,
      }),
    )
    setTimeout(() => setOpenSuccessSnackBar(false), 2000)
  }

  return (
    <>
      <div className={classes.container}>
        <Modal
          open={refreshData && refreshData.fetchInProgress && isInitiateAmendOpen === false}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <CircularProgress
              style={{ marginLeft: '45%', marginTop: '40vh', position: 'absolute', color: '#0A688D' }}
            />
            <Typography
              style={{
                fontWeight: 'bolder',
                color: 'rgba(255,255,255,0.8)',
                fontSize: 'larger',
                marginLeft: '35%',
                marginTop: '47vh',
                position: 'absolute',
              }}
            >
              Refreshing the case details from LabOS...
            </Typography>
          </div>
        </Modal>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box>
            <PatientCaseHistory userDetails={userDetails} handleClose={handleClose} />
          </Box>
        </Modal>
        <TransferCaseModal
          open={transferModalOpen}
          isSearch={false}
          trfId={null}
          userId={userId}
          onClose={handleTransferModalClose}
          userDetails={userDetails}
          setFirstPage={setFirstPage}
          filterName={filterName}
          filterValue={filterValue}
          sortField={sortField}
          startDate={endDate}
          endDate={endDate}
        />
        <TransferCorrectCaseModal
          open={correctionTransferModalOpen}
          userId={userId}
          isSearch={false}
          trfId={null}
          onClose={handleCorrectionTransferModalClose}
          userDetails={userDetails}
          setFirstPage={setFirstPage}
          filterName={filterName}
          filterValue={filterValue}
          sortField={sortField}
          startDate={endDate}
          endDate={endDate}
        />
        {openSnackBar && re_amend_success && (
          <SuccessSnackBar key={`${openSnackBar}`} message="Successfully moved the case for amend" />
        )}
        {openSnackBar && re_amend_error && (
          <ErrorSnackBar
            key={`error${openSnackBar}`}
            message="The selected case is already moved to either amend or correction"
          />
        )}
        <AmendCaseModal
          open={amendModalOpen}
          userId={userId}
          loading={loading}
          onClose={handleAmendModalClose}
          userDetails={userDetails}
          handleAmendCase={handleAmendCase}
        />
        <AssignCaseModal
          open={assignModalOpen}
          userId={userId}
          isSearch={false}
          trfId={null}
          onClose={handleAssignModalClose}
          userDetails={userDetails}
          setFirstPage={setFirstPage}
          filterName={filterName}
          filterValue={filterValue}
          sortField={sortField}
          startDate={endDate}
          endDate={endDate}
        />
        {openSnackBar && re_unassignCase_success && <SuccessSnackBar message="Successfully unassigned the case" />}
        {openSnackBar && re_unassignCase_error && <ErrorSnackBar message="Unable to unassign the case" />}
        {openSuccessSnackBar && re_amendReport_success && (
          <SuccessSnackBar message="Successfully updated case status" />
        )}
        {openSuccessSnackBar && re_amendReport_error && <ErrorSnackBar message="Failed to update case status" />}
        {resetAssignmentOpen && (
          <DeleteDialog
            header="Unassign"
            open={resetAssignmentOpen}
            onClose={handleResetAssignmentClose}
            handleSubmit={handleSubmit}
          />
        )}
        <Dialog
          open={isInitiateAmendOpen}
          onClose={handleInitiateAmendClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          classes={{ paper: classes.discardDialogHeight }}
        >
          <DialogTitle className={classes.dialogTitle}>Initiating Amendment</DialogTitle>
          <DialogContent className={classes.discardDialogContent}>
            <DialogContentText id="alert-dialog-description">
              {loadingStatus && (
                <div style={{ display: 'flex' }}>
                  <div style={{ marginTop: '10px' }}>
                    <CircularProgress
                      style={{ color: '#0A688D', marginRight: '10px', height: '20px', width: '20px' }}
                    />
                  </div>
                  <div>Updating the case demographic information. This will take a few moments.</div>
                </div>
              )}
            </DialogContentText>
          </DialogContent>
        </Dialog>
        <div className={classes.mt}>
          <Box
            sx={{
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#0d688d73',
                fontWeight: '600',
              },
              '& .MuiDataGrid-columnHeader--moving': {
                backgroundColor: 'transparent !important',
              },
              '& .MuiDataGrid-cell:hover': {
                cursor: 'pointer !important',
              },
              '& .MuiDataGrid-filterForm': { p: 2 },
            }}
          >
            {display_labels && !isSearchTable && (
              <DataGrid
                disableColumnSelector
                autoHeight
                pagination
                pageSize={10}
                rowsPerPageOptions={[10]}
                paginationMode="server"
                rows={displayAssignedData}
                rowCount={totalCount}
                page={isFirstPage ? 0 : pageValue}
                columns={ColumnsCustomFilters(tableColumns)}
                loading={reducerData?.fetchInProgress}
                onPageChange={(page, details) => {
                  setPageValue(page)
                  setFirstPage(false)
                  handlePageChange(page, details)
                }}
                onCellClick={(params, event) => {
                  event.defaultMuiPrevented = true
                  if (params.field === '') {
                    return
                  } else {
                    setReadOnlyMode(true)
                    handlePremerisOpen(event, params.row.case_id, displayAssignedData)
                  }
                }}
                filterModel={filterModel}
                onFilterModelChange={(model) => onFilterChange(model)}
                componentsProps={{
                  filterPanel: {
                    filterFormProps: {
                      // Customize inputs by passing props
                      columnInputProps: {
                        variant: 'outlined',
                        size: 'small',
                        sx: { mt: 'auto' },
                      },
                      operatorInputProps: {
                        variant: 'outlined',
                        size: 'small',
                        sx: { mt: 'auto' },
                      },
                      valueInputProps: {
                        required: true,
                      },
                    },
                    sx: {
                      // Customize inputs using css selectors
                      '& .MuiDataGrid-filterForm': {
                        p: 2,
                        display: 'block',
                        width: 'fit-content',
                        justifyContent: 'flex-start',
                      },
                      '& .MuiDataGrid-filterForm:nth-child(even)': {},
                      '& .MuiDataGrid-filterFormLinkOperatorInput': { mr: 2 },
                      '& .MuiDataGrid-filterFormColumnInput': { mr: 2, width: 150 },
                      '& .MuiDataGrid-filterFormOperatorInput': { mr: 2 },
                      '& .MuiDataGrid-filterFormValueInput': { width: 'fit-content' },
                    },
                  },
                  panel: {
                    sx: {
                      '& .MuiDataGrid-panelWrapper': { overflow: 'visible' },
                      '& .MuiDataGrid-panelContent': { overflow: 'visible', display: 'flex' },
                      '& .MuiFormControl-root': {
                        width: 'auto',
                        minWidth: '55px',
                        marginRight: '18px',
                        justifyContent: 'end',
                      },
                    },
                  },
                }}
                onSortModelChange={(newSortModel) => {
                  if (newSortModel.length) setSortField(newSortModel[0].field)
                  setPageValue(0)
                  handleFilteredPageChange(pageValue, newSortModel)
                }}
              />
            )}
            {isSearchTable && (
              <DataGrid
                getRowId={(row) => row.rowId}
                disableColumnSelector
                disableColumnFilter
                autoHeight
                pagination
                pageSize={10}
                rowsPerPageOptions={[10]}
                rows={displayAssignedData}
                columns={tableColumns}
                loading={reducerData?.fetchInProgress}
                onCellClick={(params, event) => {
                  event.defaultMuiPrevented = true
                  if (params.field === '') {
                    return
                  } else {
                    setReadOnlyMode(true)
                    handlePremerisOpen(event, params.row.case_id, displayAssignedData)
                  }
                }}
              />
            )}
          </Box>
        </div>
      </div>
      <Modal
        open={premerisOpen}
        onClose={handlePremerisClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <LaunchPremeris
          caseView={caseView}
          urlLink={findUrl}
          handlePremerisClose={handlePremerisClose}
          handleTRFComplete={handleTRFComplete}
          isReadOnlyMode={isReadOnlyMode}
          isAmendFlow={isAmendFlow}
        />
      </Modal>
    </>
  )
}

export default TableComponent
